import { render, staticRenderFns } from "./insertionEditorTutorial.vue?vue&type=template&id=0ecaaaaa&"
import script from "./insertionEditorTutorial.vue?vue&type=script&lang=ts&"
export * from "./insertionEditorTutorial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports